import service from '@/utils/request'

export const useParamsApi = (id: number) => {
    return service.get('/sys/params/' + id)
}

export const useParamsName = async (name: string) => {
    return (await service.get('/sys/params/name/' + name)).data
}
export const useParamsAllApi = () => {
    return service.get('/sys/params/all')
}

export const useParamsSubmitApi = (dataForm: any) => {
    if (dataForm.id) {
        return service.put('/sys/params', dataForm)
    } else {
        return service.post('/sys/params', dataForm)
    }
}
